import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API, useAuth } from "../context/AuthContext";

export default function History() {
  const { authHeaders } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await axios.get(`${API}/history`, { headers: authHeaders() });
      setItems(res.data);
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-14" data-testid="history-page">
      <span className="text-xs tracking-[0.2em] uppercase text-[#C66A51]">History</span>
      <h1 className="font-display text-4xl font-semibold text-[#2C4C3B] mt-1">Your searches</h1>

      {items.length === 0 ? (
        <div className="mt-10 p-10 rounded-2xl border border-dashed border-[#E2E8F0] text-[#52606D] text-center" data-testid="history-empty">
          No searches yet.
        </div>
      ) : (
        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          {items.map((h) => (
            <Link key={h.id} to={`/results/${h.id}`}
              className="p-6 rounded-2xl bg-white border border-[#E2E8F0] card-lift"
              data-testid={`history-item-${h.id}`}>
              <div className="flex items-center justify-between text-xs tracking-[0.15em] uppercase">
                <span className="text-[#C66A51]">{h.communicator_stage_title}</span>
                <span className="text-[#52606D]">{new Date(h.created_at).toLocaleDateString()}</span>
              </div>
              <div className="font-display text-xl text-[#2C4C3B] mt-2">{h.activity_name}</div>
              <div className="text-sm text-[#52606D] mt-1">{h.disorder_name} · {h.severity_label}</div>
              <div className="text-xs text-[#2C4C3B] mt-3">{h.rows.length} programming rows →</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
